import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import qs from "qs";
import React, { createContext, useEffect, useState } from "react";
import { Container, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { PROVIDER_ID } from "../../config";
import {
  getBlackoutDate,
  getEnrollmentInputs,
  getEnrollmentRecord,
} from "../../fetch/enrollment";
import {
  fetchConstellationPlans,
  fetchRateCompare
} from "../../fetch/fetch";
import type {
  Address,
  EnrollmentFields,
  PlanProps,
  Utilities,
} from "../../types";
import { FormLoading } from ".././FormLoading";
import { ProcessBar } from "../enrollment/ProcessBar";
import { EnrollmentStepConfirmation } from "../enrollment/StepConfirmation";
import { EnrollmentStepInfo } from "../enrollment/StepInfo";
import { EnrollmentStepReview } from "../enrollment/StepReview";
import { EnrollmentStepService } from "../enrollment/StepService";
import {
  AsideBox,
  AsideBoxBody,
  AsideBoxHeader,
  BenefitsCol,
  BenefitsIcon,
  BenefitsRow,
  EnrollmentAside,
  EnrollmentContainer,
  EnrollmentMain,
  PlanSummaryPromote,
  PlanSummaryRow,
} from "../styles/Enrollment.styled";
import { PlanModal } from "./PlanModal";
import { RateCompare } from "./RateCompare";
// import { toast } from 'react-toastify'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ErrorModal } from "./ErrorModal";
import { PaymentStepReview } from "./StepPayment";
import { openPdfInNewTab } from "../consteNew/utils";

export const EnrollmentContext = createContext<any>(null);

const Enrollment = () => {
  const { t } = useTranslation("enrollment");
  const navigate = useNavigate();
  const location = useLocation();
  const { product_id, utility_code, utm_content } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  const [step, setStep] = useState(1);
  const [enrollmentId, setEnrollmentId] = useState("");
  const [enrollmentResult, setEnrollmentResult] = useState(undefined);
  const [dynamicFields, setDynamicFields] = useState(undefined);
  const [sign, setSign] = useState("");
  const [specialPro, setSpecialPro] = useState({ ssn: "", date_of_birth: "" });
  const [serviceAddress, setServiceAddress] = useState<Address[]>([]);
  const [utility, setUtility] = useState<Utilities | undefined>(undefined);
  const [products, setProducts] = useState<PlanProps[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<PlanProps | undefined>(
    undefined
  );
  const [holidays, setHolidays] = useState<any>(undefined);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [productField, setProductField] = useState("");
  const [loading, setLoading] = useState(false);
  const [marketAvg, setMarketAvg] = useState("");
  const [name, setName] = useState("");
  const [promoCode, setPromoCode] = useState("");
  const [errorModalContent, setErrorModalContent] = useState<any>(undefined);
  const changeServiceAddress = (val: Address[]) => setServiceAddress(val);
  const storePromoCode = (val: string) => setPromoCode(val);
  const handleSetErrorModalContent = (val: any) => setErrorModalContent(val);
  const [showEnrollment, setShowEnrollment] = useState(false);
  const [email, setEmail] = useState('');
  const [selectedTerm, setSelectedTerm] = useState("12");
  const [historyData, setHistoryData] = useState<EnrollmentFields | undefined>(
    undefined
  );
  const { status } = useParams();
  useEffect(() => {
    const promo_code = localStorage.getItem('promoCode');
    if (promo_code) {
      storePromoCode(promo_code);
    }
  }, [])
  useEffect(() => {
    if (serviceAddress.length === 0) return;
    getEnrollmentInputs(PROVIDER_ID, serviceAddress[0].esiid).then((res) => {
      if (res && parseInt(res.status) === 1) {
        setDynamicFields(res.response);
      } else {
        console.error("Failed to fetch input fields");
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceAddress]);

  useEffect(() => {
    getProduct();
  }, []);

  useEffect(() => {
    if (status && (status === 'success' || status === 'failed')) {
      navigate(`/${location.search}`)
    }
  }, []);

  useEffect(() => {
    if (status && status === 'step1') return setStep(1);
    if (status && status !== 'step1') {
      let plan = localStorage.getItem("ts_plan");
      if (plan) {
        setSelectedProduct(JSON.parse(plan));
        saveProductField(JSON.parse(plan));
      }
      switch (status) {
        case "step2":
          return setStep(2);
        case "step3":
          return setStep(3);
        case "deposit":
          return setStep(4);
        case "failed":
        case "success":
          return setStep(5);
        default:
          navigate("/404");
      }
    }
  }, [status]);

  const changeUtility = (val: any) => {
    if (!val) {
      setUtility(val);
    } else if (val.utility_code !== utility?.utility_code) {
      setUtility(val);
      getProducts(val);
      localStorage.setItem("utility", JSON.stringify(val));
    } else {
      setUtility(val);
    }
  };
  const getProduct = () => {
    let _selectPorudct: any = localStorage.getItem("selectProduct");
    let _utility: any = localStorage.getItem("utility");
    let _address: any = localStorage.getItem("selectedAddress");
    if (_address) {
      let arr = [];
      arr.push(JSON.parse(_address));
      setServiceAddress(arr);
    }
    if (_utility && _selectPorudct) {
      setUtility(JSON.parse(_utility));
      setProductField(JSON.parse(_selectPorudct).product);
      setSelectedProduct(JSON.parse(_selectPorudct));
      setShowEnrollment(true);
      setSelectedTerm(JSON.parse(_selectPorudct).contract_term);
    } else {
      // navigate("/");
    }
  };

  useEffect(() => {
    getHolidays();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [utility, productField]);

  const getHolidays = (serviceVal?: { value: string }) => {
    if (!productField || !utility || !(serviceAddress.length > 0)) return;
    let serviceType = serviceVal?.value === "1" ? "MoveIn" : "Switching"
    getBlackoutDate(productField, utility.zipcode, utility.utility_code, serviceAddress?.[0]?.esiid || '', serviceType).then(
      (res: any) => {
        if (Number(res.status) === 1) {
          setHolidays(res.response);
        }
      }
    );
  };

  useEffect(() => {
    if (!selectedProduct) return;
    let term = selectedProduct.contract_term.toString();
    getRateCompare(
      utility_code ? `${utility_code}` : utility ? utility.utility_code : "",
      term
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProduct]);

  useEffect(() => {
    let sign_token = localStorage.getItem("sign_token");

    if (!sign_token) return;
    let _sign_token = JSON.parse(sign_token);
    setEnrollmentId(_sign_token.enrollmentId);
    setSign(_sign_token.sign);
    getEnrollmentRecord(_sign_token.enrollmentId, _sign_token.sign).then(
      (res) => {
        if (res && res.response) {
          setHistoryData(res.response);
        }
      }
    );
  }, []);

  const getRateCompare = (utility_code: string, term: string) => {
    if (!utility_code || !term) return;

    fetchRateCompare(utility_code, term).then((res) => {
      if (res && parseInt(res.status) === 1) {
        setMarketAvg(res.response.total_average_price);
      }
    });
  };

  const saveProductField = (product: PlanProps) => {
    // const eflDoc = product.productDocuments.filter((item) => item.productDocumentLanguageName === 'English' && item.productDocumentTypeName === 'EFL');
    // let productObj = {
    //     'RateID': product.productID,
    //     'Provider_ID': PROVIDER_ID,
    //     'utility_name': utility ? encodeURIComponent(utility.utility_name) : '',
    //     'energy_charge1': product.rawCommodityPrice / 100,
    //     'base_fee1': product.baseFee,
    //     'efl_url': eflDoc[0].documentURL
    // }
    setProductField(product.product);
  };

  const getProducts = (val?: any) => {
    let _utility = val ? val : utility;
    if (!_utility) return;
    setLoading(true);
    const utilityCode = _utility.utility_code;
    const zipcode = serviceAddress[0]?.zipcode;
    const term = selectedTerm ? selectedTerm : "12";
    const provider_id = PROVIDER_ID;
    const usages = new Array(12).fill(parseInt("1000"));

    fetchConstellationPlans(
      zipcode,
      utilityCode,
      term,
      provider_id,
      usages,
      promoCode
    ).then((res) => {
      if (res && Number(res.status) === 1) {
        const { plans } = res.response;
        if (plans) {
          var _plans = plans.filter(
            (item: any) => item.plan_name.indexOf("Flat Tier Product") === -1
          );
          setProducts(_plans);
          setShowPlanModal(true);
        }
      } else {
        setProducts([]);
      }
      setLoading(false);
    });
  };

  return (
    <div>
      <Container>
        {showEnrollment && (
          <EnrollmentContainer>
            <EnrollmentMain>
              <ProcessBar step={step} />
              <EnrollmentContext.Provider
                value={{
                  serviceAddress,
                  selectedProduct,
                  utility,
                  holidays,
                  loading,
                  promoCode,
                  changeServiceAddress,
                  changeUtility,
                  storePromoCode,
                  handleSetErrorModalContent,
                  getHolidays,
                  historyData,
                }}
              >
                <EnrollmentStepService
                  show={step === 1}
                  handleContinue={(id: string, sign: string) => {
                    setEnrollmentId(id);
                    setSign(sign);
                    navigate(`/enrollment/step2${location.search}`);
                    // setStep(2);
                    window.scrollTo(0, 0);
                    let token = { sign: sign, enrollmentId: id };
                    localStorage.setItem("sign_token", JSON.stringify(token));
                    localStorage.setItem(
                      "ts_plan",
                      JSON.stringify(selectedProduct)
                    );
                  }}
                  product={productField}
                // handleClearSelectedProduct={() => setSelectedProduct(undefined)}
                />
                <EnrollmentStepInfo
                  show={step === 2}
                  handleBack={() => {
                    // setStep(1);
                    navigate(`/enrollment/step1${location.search}`);
                    window.scrollTo(0, 0);
                  }}
                  handleContinue={(val: any) => {
                    setSpecialPro(val);
                    // setStep(3);
                    navigate(`/enrollment/step3${location.search}`);
                    window.scrollTo(0, 0);
                  }}
                  enrollmentId={enrollmentId}
                  dynamicFields={dynamicFields}
                  product={productField}
                  sign={sign}
                  specialPro={specialPro}
                />
                <EnrollmentStepReview
                  show={step === 3}
                  enrollmentId={enrollmentId}
                  handleContinue={(val: any) => {
                    setEnrollmentResult(val);
                    setStep(5);
                    window.scrollTo(0, 0);
                  }}
                  handlePayment={(val: any) => {
                    setEnrollmentResult(val);
                    setStep(4);
                    window.scrollTo(0, 0);
                  }}
                  handleBack={() => {
                    navigate(`/enrollment/step2${location.search}`);
                    // setStep(2);
                    window.scrollTo(0, 0);
                  }}
                  sign={sign}
                  specialPro={specialPro}
                  handleSSN={(val: any) => {
                    val.ssn = "";
                    setSpecialPro(val);
                    setStep(5);
                    window.scrollTo(0, 0);
                  }}
                  handleSetName={(val: string) => setName(val)}
                  handleSetEmail={(val: string) => setEmail(val)}
                  product={productField}
                />
                <PaymentStepReview
                  handleContinue={(val: any) => {
                    setEnrollmentResult(val);
                    setStep(5);
                    window.scrollTo(0, 0);
                  }}
                  handleBack={() => {
                    navigate(`/enrollment/step3${location.search}`)
                    setStep(3);
                    window.scrollTo(0, 0);
                  }}
                  enrollmentResult={enrollmentResult}
                  show={step === 4}
                  sign={sign}
                  enrollmentId={enrollmentId}
                  utility={utility}
                  handleSetName={(val: string) => setName(val)}
                  specialPro={specialPro}
                  handleSSN={(val: any) => {
                    val.ssn = "";
                    setSpecialPro(val);
                    setStep(5);
                    window.scrollTo(0, 0);
                  }}
                />
                <EnrollmentStepConfirmation
                  result={enrollmentResult}
                  name={name}
                  email={email}
                  show={step === 5}
                  sign={sign}
                  enrollmentId={enrollmentId}
                />
              </EnrollmentContext.Provider>
            </EnrollmentMain>
            <EnrollmentAside>
              {marketAvg &&
                selectedProduct &&
                marketAvg > selectedProduct.price1000 && (
                  <AsideBox whiteBg className="mt-4">
                    <AsideBoxHeader>
                      <div>
                        <img
                          src="/images/total_saving.png"
                          alt=""
                          width={100}
                          height={100}
                        />
                        <h5>Total Saving:</h5>
                      </div>
                      <h4 style={{ color: "#0bcebb" }}>
                        {Math.round(
                          ((parseFloat(marketAvg) -
                            parseFloat(selectedProduct.price1000)) /
                            parseFloat(selectedProduct.price1000)) *
                          10000
                        ) / 100}
                        %
                      </h4>
                    </AsideBoxHeader>
                    <AsideBoxBody>
                      <RateCompare
                        marketAvg={marketAvg}
                        product={selectedProduct}
                      />
                    </AsideBoxBody>
                  </AsideBox>
                )}
              {selectedProduct && (
                <AsideBox>
                  <AsideBoxBody>
                    <PlanReview data={selectedProduct} />
                  </AsideBoxBody>
                </AsideBox>
              )}

              {/* <AsideBox whiteBg className="mt-4">
                            <Image src='/images/icon-shop.png' alt='' width={100} height={100} />
                            <h4>SHOP FOR YOUR</h4>
                            <h4>HOME</h4>
                        </AsideBox> */}
            </EnrollmentAside>
          </EnrollmentContainer>
        )}
        {!showEnrollment && <></>}

        <PlanModal
          show={showPlanModal}
          handleClose={() => {
            // setShowPlanModal(false)
          }}
          hideCloseButton={true}
          data={products}
          selectProduct={(product: PlanProps) => {
            setSelectedProduct(product);
            setShowPlanModal(false);
            saveProductField(product);
            // navigate(`/?product_id=${product.productID}&utility_code=${utility?.utility_code}`, {
            //     replace: true,
            // })
          }}
          promoCode={promoCode}
        />
        <ErrorModal
          content={errorModalContent}
          handleClose={() => setErrorModalContent(undefined)}
        />
        <FormLoading show={loading} />
      </Container>
    </div>
  );
};

interface PlanReviewProps {
  data: any | undefined;
}

const PlanReview: React.FC<PlanReviewProps> = ({ data }) => {
  const { t } = useTranslation("plan");
  const [showBenefitModal, setShowBenefitModal] = useState(false);
  if (!data) {
    return (
      <p className="text-center" style={{ fontSize: 14, color: "#999" }}>
        Please Enter Service Address
      </p>
    );
  }
  const {
    isEbillRequired,
    provider_id,
    plan_name,
    price1000,
    contract_term,
    cancel_fee,
    cancel_fee_type,
    plan_incentive_list
  } = data;

  return (
    <>
      <div className="d-flex align-items-center mb-4">
        <div className="rep-logo me-3">
          <img src="/images/logo.png" alt="" />
        </div>
        <div className="plan-name">{plan_name}</div>
      </div>
      <div>
        <PlanSummaryRow>
          <label>Rate (Based on 1,000 kWh):</label>
          <span>
            <b>{`${parseFloat(price1000)?.toFixed(1)}¢`}</b>
          </span>
        </PlanSummaryRow>
        <PlanSummaryRow>
          <label>{t("Plan Length")}:</label>
          <span>{contract_term} Months</span>
        </PlanSummaryRow>
        {
          plan_incentive_list?.find((incentive: any) => incentive.Description === 'Gift Card') &&
          <div>
            <PlanSummaryRow>
              <label>Gift Card{/* (Based on 1,000 kWh) */}:</label>
              <span>
                <b>${plan_incentive_list?.find((incentive: any) => incentive.Description === 'Gift Card')?.Value}</b>
              </span>
            </PlanSummaryRow>
          </div>
        }
        <PlanSummaryRow>
          <label>{t("Cancellation Fee")}:</label>
          <span style={{ textAlign: "right" }}>
            {`${cancel_fee} (${cancel_fee_type})`}
          </span>
        </PlanSummaryRow>
      </div>
      <div className="plan-links mt-3">
        <PlanSummaryRow key={1} narrow>
          <span onClick={(e) => { e.preventDefault(); openPdfInNewTab(data.yrac); }} style={{ cursor: 'pointer' }}>
            <FontAwesomeIcon icon="file-pdf" />
            <span className="ms-2">YRAC</span>
          </span>
        </PlanSummaryRow>

        <PlanSummaryRow key={2} narrow>
          <span onClick={(e) => { e.preventDefault(); openPdfInNewTab(data.terms_url); }} style={{ cursor: 'pointer' }}>
            <FontAwesomeIcon icon="file-pdf" />
            <span className="ms-2">TOS</span>
          </span>
        </PlanSummaryRow>

        <PlanSummaryRow key={3} narrow>
          <span onClick={(e) => { e.preventDefault(); openPdfInNewTab(data.efl_url); }} style={{ cursor: 'pointer' }}>
            <FontAwesomeIcon icon="file-pdf" />
            <span className="ms-2">EFL</span>
          </span>
        </PlanSummaryRow>
      </div>
      <PlanSummaryPromote>
        {isEbillRequired && <span>Plan requires electronic billing. </span>}
        Please print or save these documents for your reference.
      </PlanSummaryPromote>
      <Modal
        size="lg"
        show={showBenefitModal}
        onHide={() => setShowBenefitModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>FREE Pack Benefits</Modal.Title>
          <p>Get the support and protection every pet parent deserves.</p>
        </Modal.Header>
        <Modal.Body>
          <BenefitsRow>
            <BenefitsCol>
              <BenefitsIcon>
                <img src="/images/videovetpink.svg" alt="" />
              </BenefitsIcon>
              <h5>24/7 Video Vet</h5>
              <p>
                Free access to instant, compassionate vet care for your pet. You
                never know when your pet will need a vet. When they do,
                Constellation Video Vet will be there. Covers up to 5 pets!
              </p>
            </BenefitsCol>
            <BenefitsCol>
              <BenefitsIcon>
                <img src="/images/emergencyfundpink.svg" alt="" />
              </BenefitsIcon>
              <h5>$750 Emergency Fund</h5>
              <p>
                Not everything can be solved remotely. Once per year, you can
                tap into a $750 emergency fund for an urgent visit to any vet.
                You pay $0 out of pocket.
              </p>
            </BenefitsCol>
            <BenefitsCol>
              <BenefitsIcon>
                <img src="/images/rounduppink.svg" alt="" />
              </BenefitsIcon>
              <h5>Roundup for Rescues</h5>
              <p>
                Constellation will roundup your bill each month and donate the
                proceeds to our rescue partner of your choice - at no cost to
                you!
              </p>
            </BenefitsCol>
          </BenefitsRow>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Enrollment;
